import notificationsTopics from "./notificationsTopic";

export default {
  myHomeHomeStripe: [
    notificationsTopics.ACTIVATION_EXPIRED,
    notificationsTopics.ACTIVATION_EXPIRING,
    notificationsTopics.ACTIVATION_NEW,
    notificationsTopics.EVALUATION_EXPIRING,
    notificationsTopics.EVALUATION_NEW,
  ],
  myHomeBooksStripe: [
    notificationsTopics.ACTIVATION_EXPIRED,
    notificationsTopics.ACTIVATION_EXPIRING,
    notificationsTopics.ACTIVATION_NEW,
    notificationsTopics.EVALUATION_EXPIRING,
    notificationsTopics.EVALUATION_NEW,
  ],
  myHomeBookBadge: [
    notificationsTopics.ACTIVATION_NEW,
    notificationsTopics.EBOOK_NEW,
    notificationsTopics.EVALUATION_EXPIRED,
    notificationsTopics.EVALUATION_NEW,
    notificationsTopics.INDEX_NEW,
  ],
  minisiteBookBadge: [
    notificationsTopics.ACTIVATION_NEW,
    notificationsTopics.EBOOK_NEW,
    notificationsTopics.EVALUATION_NEW,
    notificationsTopics.INDEX_NEW,
  ],
};
